export default "__VITE_ASSET__0950a5e3__"